// extracted by mini-css-extract-plugin
export default {"navigationLink":"PrescriptionRenewalsViewNavigationBar_navigationLink__TSNVa","active":"PrescriptionRenewalsViewNavigationBar_active__sofdg"};